import React, { useEffect, useState } from 'react'
import { 
  FiGift, 
  FiPercent, 
  FiHash, 
  FiRefreshCw,
  FiPlus,
  FiTrash2,
  FiEdit2,
  FiToggleLeft,
  FiToggleRight,
  FiCheckCircle,
  FiXCircle,
  FiUsers,
  FiAward,
  FiTag,
  FiGrid,
  FiList,
  FiSearch,
  FiFilter,
  FiClock,
  FiDollarSign,
  FiStar,
  FiUserPlus,
  FiTrendingUp,
  FiSettings,
  FiEye,
  FiLink,
  FiGift as FiGiftIcon
} from "react-icons/fi";
import { 
  MdOutlineSettings,
  MdOutlineAdd,
  MdOutlineDelete,
  MdOutlineEdit,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlineMoreVert,
  MdOutlineGift,
  MdOutlineCardGiftcard,
  MdOutlineLocalOffer
} from "react-icons/md";
import { IoGiftOutline, IoTicketOutline, IoShareSocialOutline } from "react-icons/io5";
import Button from '../../components/Button/Button'
import Card from '../../components/Card/Card'
import card1icon from "../../public/images/card1.svg"
import card2icon from "../../public/images/card2.svg"
import card3icon from "../../public/images/card3.svg"
import card4icon from "../../public/images/card4.svg"
import ReferalTable from './Table/ReferalTable'
import RewardTable from './Table/RewardTable'
import ReferalCreateModal from './Modal/ReferalCreateModal'
import RewardCreateModal from './Modal/RewardCreateModal'
import { useDispatch, useSelector } from 'react-redux'
import { createReferral, deleteReferral, getReferralList, toggleReferral } from '../../Redux/referralAndRewardSlice'
import { getAllCategorys, refCounts } from '../../Redux/preferenceSlice'
import SimpleDeleteModal from '../../components/Delete Modal/SimpleDeleteModal'
import { toast } from 'react-toastify'

const feildsVlaue = { rewardname: "", rewardValue: "", condition: "" }

const ReferalRewardMangment = () => {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const { referralAndRewardSlice: { referralData = [], totalReferralData = 0 }, preferenceSlice: { preference = [] } } = selector ? selector : {}
  const [activeTab, setActiveTab] = useState('ReferralCodeManagement')
  const [isDeleteModal, setIsDeleteModal] = useState(false)
  const [isCreateReferalModal, setIsCreateReferalModal] = useState(false)
  const [isCreateRewardModal, setIsCreateRewardModal] = useState(false)
  const [rewardCreateInputs, setRewardsCreateInput] = useState(feildsVlaue)
  const [cate, setCate] = useState()
  const [inputData, setInputData] = useState({
    referralName: "", count: "", discount: ""
  })
  const [keyword, setKeyword] = useState('')
  const [deleteData, setDeleteData] = useState(null)
  const referralThead = ['#', 'Referral Code', 'Status', 'Associated Reward', 'Action'];
  const rewardThead = ['#', 'Reward Name', 'Reward Type', 'Status', 'Associated Reward', 'Conditions', 'Action'];

  const rewardData = [{ id: 1, name: 'SUMO123', type: 'Discount', status: true, reward: "10% Discount", Conditions: 'none' },]
  const [pageNo, setpageNo] = useState(1)
  const [size, setSize] = useState(5)
  const [errors, setErrors] = useState({});

  const deleteAction = (data) => {
    setIsDeleteModal(!isDeleteModal)
    setDeleteData(data)
  }

  const handleCreateReferal = (identify) => {
    { identify === 'REFERAL' ? setIsCreateReferalModal(!isCreateReferalModal) : setIsCreateRewardModal(!isCreateRewardModal) }
  }

  const toggleReferalCreateModal = () => {
    setIsCreateReferalModal(!isCreateReferalModal)
    setInputData({
      referralName: "", count: "", discount: ""
    })
    setCate()
  }

  const toggleRewardCreateModal = () => { setIsCreateRewardModal(!isCreateRewardModal) }

  const handleOnChnage = (e) => {
    const { name, value } = e.target
    setRewardsCreateInput({ ...rewardCreateInputs, [name]: value })
  }

  let payload = {
    "pageNo": pageNo,
    "size": size,
    "keyWord": keyword ? keyword : ""
  }

  useEffect(() => {
    dispatch(getReferralList(payload))
    dispatch(getAllCategorys())
    dispatch(refCounts())
  }, [keyword, pageNo, size])

  let handlePageClick = (newPage) => {
    setpageNo(newPage?.selected + 1)
  }

  const handleRewardOnChange = (e) => {
    const { name, value } = e.target
    setInputData({ ...inputData, [name]: value })
  }

  const handleFormReset = () => {
    handleRewardOnChange({ target: { name: 'referralName', value: '' } });
    handleRewardOnChange({ target: { name: 'discount', value: '' } });
    handleRewardOnChange({ target: { name: 'count', value: '' } });
    setCate(null);
    setErrors({});
  }

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!inputData?.referralName || inputData?.referralName.trim() === '') {
      formErrors.referralName = 'Referral name is required';
      isValid = false;
    }

    if (!inputData?.discount || inputData?.discount.trim() === '') {
      formErrors.discount = 'Discount is required';
      isValid = false;
    }

    if (!cate || (Array.isArray(cate) && cate.length === 0)) {
      formErrors.preference = 'At least one preference must be selected';
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const apiPayload = {
        ReferralCode: inputData.referralName,
        count: '1',
        percentDiscount: inputData.discount,
        courseCategory: Array.isArray(cate) ? cate.map(item => item.value) : [cate.value]
      };

      dispatch(createReferral({ Payload: apiPayload, forReferesh: payload })).then((res) => {
        if (res?.payload?.error) {
          toast.error(res?.payload?.message)
        } else {
          toast.success(res?.payload?.message)
          handleFormReset();
          toggleReferalCreateModal();
        }
      }).catch((err) => {
        toast.error(err)
        console.log("Error", err)
      })
    }
  }

  const toggleDeleteModal = () => { setIsDeleteModal(!isDeleteModal) }

  const handleDelete = () => {
    let deletePayload = {
      referralCode: deleteData?.ReferralCode
    }
    dispatch(deleteReferral({ Payload: deletePayload, forReferesh: payload })).then((res) => {
      if (res?.payload?.error) {
        toast.error(res?.payload?.message)
      } else {
        toast.success(res?.payload?.message)
        setIsDeleteModal(false)
        setDeleteData(null)
      }
    }).catch((err) => {
      toast.error(err)
      console.log("Error", err)
    })
  }

  const handleToggle = (data) => {
    let togglePayload = {
      id: data?._id
    }
    dispatch(toggleReferral({ Payload: togglePayload, forReferesh: payload }));
  };

  let { preferenceSlice } = selector ? selector : {}
  let { refcount } = preferenceSlice ? preferenceSlice : {}

  // Calculate statistics
  const totalReferrals = refcount?.totalRefCodes || 0;
  const activeDiscount = refcount?.activeReferralsInfo?.[0]?.percentDiscount || 0;
  const activeReferralCode = refcount?.activeReferralsInfo?.[0]?.ReferralCode || 'N/A';

  // Stats cards data
  const statsCards = [
    {
      title: 'Total Referrals',
      count: totalReferrals,
      icon: FiUsers,
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600',
      subtitle: 'Total referral codes'
    },
    {
      title: 'Active Discount',
      count: `${activeDiscount}%`,
      icon: FiPercent,
      color: 'from-emerald-500 to-emerald-600',
      bgColor: 'bg-emerald-50',
      textColor: 'text-emerald-600',
      subtitle: 'Current discount rate'
    },
    {
      title: 'Active Referral Code',
      count: activeReferralCode,
      icon: FiTag,
      color: 'from-purple-500 to-purple-600',
      bgColor: 'bg-purple-50',
      textColor: 'text-purple-600',
      subtitle: 'Active referral code'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50/80">
      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <IoShareSocialOutline className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  Referral & Rewards System
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage referral codes and rewards
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <button
                onClick={() => handleCreateReferal('REFERAL')}
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-[#715EFE] bg-white rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                <FiPlus className="w-4 h-4" />
                <span className="hidden sm:inline">Create Referral</span>
                <span className="sm:hidden">Add</span>
              </button>
              <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-5 md:gap-4">
            {statsCards.map((card, index) => (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">
                      {card.title}
                    </p>
                    <p className="text-xl font-bold text-white md:text-2xl mt-0.5">
                      {card.count}
                    </p>
                    {card.subtitle && (
                      <p className="text-[14px] text-white/40 hidden sm:block">
                        {card.subtitle}
                      </p>
                    )}
                  </div>
                  <div className={`p-2 rounded-xl bg-gradient-to-br ${card.color} bg-opacity-30 shadow-inner`}>
                    <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          {/* Tab Navigation */}
          <div className="flex flex-wrap border-b border-gray-100 bg-gray-50/50">
            <button
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200
                ${activeTab === "ReferralCodeManagement" 
                  ? "text-[#715EFE] border-b-2 border-[#715EFE] bg-white" 
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                }
              `}
              onClick={() => setActiveTab("ReferralCodeManagement")}
            >
              <FiTag className="w-4 h-4" />
              <span>Referral Code Management</span>
              <span className="px-1.5 py-0.5 text-xs font-medium text-[#715EFE] bg-[#715EFE]/10 rounded-full">
                {totalReferrals}
              </span>
            </button>
          </div>

          {/* Content */}
          <div className="p-3 md:p-4">
            {activeTab === 'ReferralCodeManagement' && (
              <ReferalTable
                TableName={`Generate and Track Referral Codes`}
                TableHeader={referralThead}
                TableData={referralData}
                handleToggle={handleToggle}
                deleteAction={deleteAction}
                handleCreateModal={handleCreateReferal}
                keyword={keyword}
                setKeyword={setKeyword}
                pageNo={pageNo}
                setpageNo={setpageNo}
                size={size}
                total={totalReferralData}
                setSize={setSize}
                handlePageClick={handlePageClick}
              />
            )}
            {activeTab === 'RewardCustomization' && (
              <RewardTable
                TbaleName={`Reward Customization`}
                TbaleHeader={rewardThead}
                TbaleData={rewardData}
                handleToggle={handleToggle}
                handleCreateModal={handleCreateReferal}
              />
            )}
          </div>
        </div>
      </section>

      {/* Modals */}
      {isDeleteModal && (
        <SimpleDeleteModal
          isOpen={isDeleteModal}
          title={`Delete Referral Code`}
          description={`Are you sure you want to delete "${deleteData?.ReferralCode}"?`}
          onCancel={toggleDeleteModal}
          onDelete={handleDelete}
        />
      )}

      {isCreateReferalModal && (
        <ReferalCreateModal
          onCancel={toggleReferalCreateModal}
          title={`Generate New Referral Code`}
          preference={preference}
          setCate={setCate}
          cate={cate}
          inputData={inputData}
          handleONChange={handleRewardOnChange}
          onSubmit={onSubmit}
          errors={errors}
        />
      )}

      {isCreateRewardModal && (
        <RewardCreateModal
          onCancel={toggleRewardCreateModal}
          title={`Add New Referral Reward`}
          inputData={rewardCreateInputs}
          handleONChange={handleOnChnage}
        />
      )}
    </div>
  )
}

export default ReferalRewardMangment